import React from 'react';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const LeakDetectorStatistics = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/dashboard');
  };

  return (
    <Result
      status="404"
      title="Đang cập nhật..."
      subTitle="Xin lỗi, trang này không tồn tại hoặc đang được liên tục cập nhật."
      extra={
        <Button type="primary" onClick={handleNavigate}>
          Quay lại trang chủ
        </Button>
      }
    />
  );
};

export default LeakDetectorStatistics;
